import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  exitPropertyWalkThroughForm,
  setPropertyWalkThroughFormData,
} from '../../store/actions/propertyWalkThroughForm';
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
  fetchWalkThroughServiceList,
  downloadPDF,
} from '../../store/actions/easyWalkThroughForm';
import { selectEasyWalkThroughFormData } from '../../store/selectors/easyWalkThroughForm';
import Loader from '../Loader';
import Row from '../Row';
import Col from '../Col';
import Icon from '../Icon';
import { selectPropertyWalkThroughFormData } from '../../store/selectors/propertyWalkThroughForm';
import Avatar from '../Avatar';
import Checkbox from '../Checkbox';
import { SuccessMessages } from '../../common/constants';
import { startFormLoading, stopFormLoading } from '../../store/actions/loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { downloadDocument } from '../../helpers/DownloadDoc';
import { ToastInfo } from '../../helpers/validationHelper';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';

class ReviewWalkThrough extends Component {
  state = {
    showImages: false,
    selectedImages: [],
  };

  componentDidMount() {
    const {
      easyWalkThroughFormData,
      onFetchWalkThroughServiceList,
      downloadPDF,
      stopFormLoading,
    } = this.props;
    onFetchWalkThroughServiceList(easyWalkThroughFormData.walkThroughId);
    downloadPDF(easyWalkThroughFormData.walkThroughId);
    stopFormLoading();
  }

  async showImages(data) {
    let selectedImage;
    if (data && data.attachment) {
      selectedImage = JSON.parse(data.attachment);
      this.setState({
        selectedImages: selectedImage,
        showImages: true,
        selectedIndex: 0,
      });
    }
  }

  displayImages() {
    const { showImages, selectedImages, selectedIndex } = this.state;

    if (showImages === true) {
      return (
        <ReusableLightbox
          isOpen={showImages}
          onClose={() => this.setState({ showImages: false })}
          images={selectedImages}
          initialIndex={selectedIndex || 0}
          onIndexChange={(index) => this.setState({ selectedIndex: index })}
        />
      );
    }
  }

  checkAttachment(data) {
    if (data && data.attachment) {
      let attachment = data.attachment.split('/');
      return attachment.length > 0 ? true : false;
    } else if (data && data.Attachment && data.Attachment.length > 0) {
      return data.Attachment.length > 0 ? true : false;
    } else {
      return false;
    }
  }

  handleClose = async () => {
    const {
      propertyWalkThroughData,
      onExitPropertyWalkThroughForm,
      onExitEasyWalkThroughForm,
    } = this.props;
    await onExitEasyWalkThroughForm();
    await onExitPropertyWalkThroughForm();
    this.props.setPropertyWalkThroughFormData({
      walkthroughData: propertyWalkThroughData.walkthroughData,
    });
  };

  exportPDF = (pdfurl) => {
    ToastInfo(SuccessMessages.pdfDownloadNotification);
    downloadDocument(pdfurl);
  };

  render() {
    const {
      onExitPropertyWalkThroughForm,
      onExitEasyWalkThroughForm,
      easyWalkThroughFormData,
      pdfLoader,
    } = this.props;
    const { showImages } = this.state;

    let serviceRequests =
      easyWalkThroughFormData.walkThroughServiceRequests &&
      easyWalkThroughFormData.walkThroughServiceRequests.length > 0
        ? easyWalkThroughFormData.walkThroughServiceRequests
        : [];

    let loading =
      easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading &&
      easyWalkThroughFormData.reviewWalkThroughServiceRequestListLoading ===
        true
        ? true
        : false;

    return (
      <>
        <div class="header_section">
          <div class="header_box">
            <div class="header_back_btn">
              <div
                class="back_arrow"
                onClick={() => {
                  if (
                    easyWalkThroughFormData &&
                    easyWalkThroughFormData.type === 'Dashboard'
                  ) {
                    this.handleClose();
                  } else {
                    onExitEasyWalkThroughForm();
                    onExitPropertyWalkThroughForm();
                  }
                }}
              >
                <a href="#.">
                  <svg
                    width="21"
                    height="18"
                    viewBox="0 0 21 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                      fill="#1D1D1D"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div class="configure_heading">
              <h2>Review Walk Through</h2>
            </div>
            <div
              class="back_arrow text-right"
              onClick={() => {
                if (
                  easyWalkThroughFormData &&
                  easyWalkThroughFormData.type === 'Dashboard'
                ) {
                  this.handleClose();
                } else {
                  onExitEasyWalkThroughForm();
                  onExitPropertyWalkThroughForm();
                }
              }}
            >
              <a href="#.">
                <svg
                  width="21"
                  height="18"
                  viewBox="0 0 21 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.928968 0.929094C1.16339 0.694674 1.48133 0.562977 1.81285 0.562978C2.14437 0.562978 2.46231 0.694674 2.69673 0.929095L8.00003 6.23239L13.3033 0.929094C13.5377 0.694674 13.8557 0.562978 14.1872 0.562978C14.5187 0.562977 14.8367 0.694674 15.0711 0.929094C15.3055 1.16351 15.4372 1.48146 15.4372 1.81298C15.4372 2.1445 15.3055 2.46244 15.0711 2.69686L9.76779 8.00015L15.0711 13.3034C15.3055 13.5379 15.4372 13.8558 15.4372 14.1873C15.4372 14.5188 15.3055 14.8368 15.0711 15.0712C14.8367 15.3056 14.5187 15.4373 14.1872 15.4373C13.8557 15.4373 13.5377 15.3056 13.3033 15.0712L8.00003 9.76792L2.69673 15.0712C2.46231 15.3056 2.14437 15.4373 1.81285 15.4373C1.48133 15.4373 1.16339 15.3056 0.928968 15.0712C0.694548 14.8368 0.562852 14.5188 0.562852 14.1873C0.562853 13.8558 0.694548 13.5379 0.928969 13.3034L6.23226 8.00015L0.928969 2.69686C0.694548 2.46244 0.562853 2.1445 0.562852 1.81298C0.562852 1.48146 0.694548 1.16351 0.928968 0.929094Z"
                    fill="#1D1D1D"
                  />
                </svg>
              </a>
            </div>
          </div>
          {loading ? (
            <>
              <div style={{ justifyContent: 'center', alignItems: 'center' }}>
                <Loader center={true} />
              </div>
            </>
          ) : (
            <>
              {pdfLoader && <Loader center={true} />}
              {easyWalkThroughFormData && easyWalkThroughFormData.PDFURL && (
                <div style={{ textAlign: 'right' }}>
                  <Icon glyph="download" weight="light" />
                  <a
                    target="blank"
                    style={{ cursor: 'pointer' }}
                    onClick={() =>
                      this.exportPDF(easyWalkThroughFormData.PDFURL)
                    }
                  >
                    {' '}
                    Export to PDF
                  </a>
                </div>
              )}
              <div className="WalkthroughScroll">
                <div class="itemsCompletedTable">
                  <table cellPadding="0" cellSpacing="0">
                    <thead>
                      <tr class="table_head">
                        <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                          {' '}
                          Ticket Number{' '}
                        </th>
                        <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                          {' '}
                          Room{' '}
                        </th>
                        <th className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                          {' '}
                          Asset{' '}
                        </th>
                        <th> Issue Type</th>
                        <th> Description</th>
                        <th>
                          {' '}
                          <i
                            aria-hidden="true"
                            class="icon fa-paperclip fal f-20"
                          ></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {serviceRequests && serviceRequests.length > 0
                        ? serviceRequests.map((data) => {
                            return (
                              <tr>
                                <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                  {' '}
                                  {data.dummyId
                                    ? data.dummyId
                                    : data.ticketNumber
                                      ? data.ticketNumber
                                      : data && data.ticketId
                                        ? data.ticketId
                                        : ''}
                                </td>
                                <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                  {data.area && data.area.name
                                    ? data.area.name
                                    : data.areaName
                                      ? data.areaName
                                      : ''}
                                </td>
                                <td className="reviewTable1__data--hide-xs reviewTable1__header--hide-xs">
                                  {data.assetName
                                    ? data.assetName
                                    : data.asset
                                      ? data.asset
                                      : ''}
                                </td>
                                <td>
                                  {data.serviceType
                                    ? data.serviceType
                                    : data.issueType && data.issueType.name
                                      ? data.issueType.name
                                      : data.issueType
                                        ? data.issueType
                                        : ''}
                                </td>
                                <td>
                                  {data.description.substring(
                                    0,
                                    data.description.length > 20
                                      ? '15'
                                      : data.description.length
                                  ) +
                                    (data.description.length < 20 ? '' : '...')}
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  {this.checkAttachment(data) ? (
                                    <div
                                      className="avatarImgCenter"
                                      onClick={() => this.showImages(data)}
                                    >
                                      <Avatar
                                        badge={
                                          JSON.parse(data.attachment).length > 1
                                            ? 'count'
                                            : ''
                                        }
                                        url={JSON.parse(data.attachment)[0]}
                                      />
                                    </div>
                                  ) : (
                                    <img
                                      src="https://via.placeholder.com/640x360"
                                      alt=""
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </div>
                {easyWalkThroughFormData.walkthroughChecklistItems &&
                  easyWalkThroughFormData.walkthroughChecklistItems.length >
                    0 && (
                    <div class="ChecklistCard walkthroughChecklist">
                      <div class="chack_box_info">
                        <div class="title_chack_box">
                          <h3 className="checklistHead">
                            Walkthrough Checklist
                          </h3>
                        </div>
                        <div class="checklist">
                          <Row>
                            {easyWalkThroughFormData.walkthroughChecklistItems.map(
                              (item, i) => (
                                <Col xs="12" md="3">
                                  <div
                                    class="form-check"
                                    style={{ width: '100%' }}
                                  >
                                    <Checkbox
                                      label={item.description}
                                      value={item.ischecked}
                                    />
                                  </div>
                                </Col>
                              )
                            )}
                          </Row>
                        </div>
                      </div>
                    </div>
                  )}
                <div class="ChecklistCard walkthroughChecklist">
                  <div class="chack_box_info">
                    <div class="title_chack_box">
                      <h3 className="checklistHead"> Area Checklist</h3>
                    </div>
                    <div class="checklist">
                      <Row>
                        {easyWalkThroughFormData.areaChecklist &&
                        easyWalkThroughFormData.areaChecklist.length > 0 ? (
                          easyWalkThroughFormData.areaChecklist.map(
                            (item, i) => (
                              <>
                                {item.walkthroughChecklistItems.length > 0 && (
                                  <Col xs="12" md="6">
                                    <>
                                      <div className="checklistSubHead checklistmt-2">
                                        {item.name}
                                      </div>
                                      <Row>
                                        {item.walkthroughChecklistItems.map(
                                          (cl) => (
                                            <Col xs="12" md="6">
                                              <div
                                                class="form-check"
                                                style={{ width: '100%' }}
                                              >
                                                <Checkbox
                                                  label={cl.description}
                                                  value={cl.ischecked}
                                                />
                                              </div>
                                            </Col>
                                          )
                                        )}
                                      </Row>
                                    </>
                                  </Col>
                                )}
                              </>
                            )
                          )
                        ) : (
                          <div
                            style={{ display: 'flex', alignItems: 'center' }}
                          >
                            <div style={{ color: '#DFE3E8' }}>
                              <Icon
                                weight="regular"
                                glyph="info-circle"
                                size="medium"
                              />
                            </div>
                            <div style={{ marginLeft: 10, color: '#919EAB' }}>
                              {'There are currently no area checklists.'}
                            </div>
                          </div>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
                {easyWalkThroughFormData?.notes?.length > 0 && (
                  <div class="ChecklistCard walkthroughChecklist">
                    <div style={{ marginTop: 20 }} class="chack_box_info">
                      <h3 class="checklistHead">Notes</h3>
                      {easyWalkThroughFormData?.notes ?? ''}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        {showImages === true ? <>{this.displayImages()}</> : null}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    easyWalkThroughFormData: selectEasyWalkThroughFormData(state),
    propertyWalkThroughData: selectPropertyWalkThroughFormData(state),
    pdfLoader: selectFormLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      onFetchWalkThroughServiceList: fetchWalkThroughServiceList,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      setPropertyWalkThroughFormData,
      downloadPDF: downloadPDF,
      startFormLoading,
      stopFormLoading,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReviewWalkThrough);
